export default __webpack_public_path__ + "static/media/welfare_img.18d72f6e.jpg";